import Stack from '@mui/material/Stack';
import {type FC, useState} from 'react';
import ConfigButton from '@/components/common/ConfigButton';
import ProfilePanel from '@/components/common/ProfilePanel';
import type {User} from '@/domain/entities/User';

//TYPES
type Props = {
  user: User;
  onLogout: () => void;
};

const Profile: FC<Props> = ({user, onLogout}) => {
  const [showProfile, setShowProfile] = useState<boolean>(false);

  const {username} = user;

  return (
    <Stack direction="row" spacing={1} sx={{alignItems: 'flex-end'}}>
      <ProfilePanel user={user} onLogout={onLogout} isOpen={showProfile} onClose={() => setShowProfile(false)} />
      <ConfigButton content={username.slice(0, 2).toUpperCase()} onClick={() => setShowProfile(!showProfile)} />
    </Stack>
  );
};
export default Profile;
